/* eslint import/newline-after-import: "off" */
import { create } from 'apisauce';
import Cookies from 'js-cookie';
import jwtdecode from 'jwt-decode';
import swal from 'sweetalert';
import { BroadcastChannel } from 'broadcast-channel';
import posthog from 'posthog-js';
import { getTenantSlug } from '../utils/tenant';
 
const token = Cookies.get('token');
const tenantSlug = getTenantSlug();
 
const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
 
const apiClient = create({
  baseURL: apiEndpoint,
  timeout: 600000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache',
    Authorization: `Bearer ${token}`,
    ...(tenantSlug ? { 'X-Tenant': tenantSlug } : {}),
  },
});
 
// eslint-disable-next-line no-unused-vars
const handleTokenExpire = () => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const logoutChannel = new BroadcastChannel('logout');
 
  swal({
    text: 'Session has been expired please re-login. ',
    buttons: {
      confirm: {
        text: 'Okay',
        value: true,
        visible: true,
        className: '',
        closeModal: true,
      },
    },
    closeOnClickOutside: false,
  }).then((res) => {
    console.log(res);
 
    // logoutChannel.postMessage('Logout');
    // dispatch(logoutSuccess());
    // navigate('/login');
    // loginServices.logout();
  });
};
 
// The purpose of this function is to check the expiration of the token for each request called only with apiClient
apiClient.addAsyncRequestTransform((request) => async () => {
  const tokenExpire = Cookies.get('tokenExpireTime');
  const isLogIn = Cookies.get('isLogIn');
 
  // if (isLogIn && token) {
  //   handleTokenExpire();
  // }
  // console.log(  Date.now()  , parseInt(tokenExpire), parseInt(tokenExpire)*1000 )
  if (isLogIn && tokenExpire) {
    if (Date.now() >= parseInt(tokenExpire, 10) * 1000) {
      try {
        const loginResponse = await getNewToken(); // waiting for new token
        if (loginResponse.ok) {
          Cookies.remove('token');
          Cookies.remove('tokenExpireTime');
          const json = await loginResponse.json();
          const decoded = await jwtdecode(json.token);
          // request.headers["Authorization"] = `Bearer ${json.token}`;
          request.headers.Authorization = `Bearer ${json.token}`;
          apiClient.setHeader('Authorization', `Bearer ${json.token}`);
          Cookies.set('token', json.token);
          Cookies.set('tokenExpireTime', decoded.exp);
        }
      } catch (error) {
        console.log('error on getting token from api', error);
      }
    } else {
      // apiClient.setHeaders({ Authorization: token })
    }
  }
});
 
apiClient.addRequestTransform((request) => {
  const slug = getTenantSlug();
  if (slug) {
    request.headers['X-Tenant'] = slug;
  }
});
 
apiClient.addResponseTransform((response) => {
  if (response.status === 401 || response.status === 403) {
    const isLogIn = Cookies.get('isLogIn');
    if (!isLogIn) return;
 
    const url = response.config?.url || '';
    if (url.startsWith('/authenticate') || url.startsWith('/individual/user')) return;
 
    if (window.__forceLogoutTriggered) return;
    window.__forceLogoutTriggered = true;
 
    const message = response.status === 403
      ? 'Your account has been suspended. Please contact your administrator.'
      : 'Session expired. Please login again.';
 
    swal({
      text: message,
      icon: 'warning',
      buttons: { confirm: { text: 'OK', value: true, visible: true, closeModal: true } },
      closeOnClickOutside: false,
    }).then(() => {
      Cookies.remove('token');
      Cookies.remove('refreshToken');
      Cookies.remove('tokenExpireTime');
      Cookies.remove('isLogIn');
      localStorage.clear();
      window.__forceLogoutTriggered = false;
      window.location.href = '/login';
    });
  }
});
 
const getNewToken = () => {
  const refreshToken = Cookies.get('refreshToken');
  return Promise.race([
    fetch(`${apiEndpoint}/authenticate/refreshToken`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    }),
    new Promise((_, reject) =>
      setTimeout(() => {
        reject(new Error('timeout'));
      }, 30000)
    ),
  ]);
};

// ── PostHog: Capture all API errors globally ──
apiClient.addResponseTransform((response) => {
  if (!response.ok && response.status >= 400) {
    posthog.capture('api_error', {
      status: response.status,
      url: response.config?.url,
      method: response.config?.method?.toUpperCase(),
      error_message: response.data?.message || response.data?.error || response.problem,
      error_code: response.data?.code,
      duration_ms: response.duration,
    });
  }
  // Also capture network/timeout errors (status is null)
  if (!response.ok && !response.status) {
    posthog.capture('api_error', {
      status: 0,
      url: response.config?.url,
      method: response.config?.method?.toUpperCase(),
      error_message: response.problem || 'NETWORK_ERROR',
      error_code: response.problem,
    });
  }
});

export default apiClient;
 
 